module.exports = __webpack_public_path__ + "static/media/artichoke.eadb3a20.jpg";